import { AppConfig } from 'AppConfig';
import axios from 'axios';
import { trackClick, trackingActions, trackingTypes } from 'utils/tracking';
import { UPDATE_COMPANY_FEATURES } from 'features/user/userTypes';
import * as Types from './types';

export const fetchStateList = () => {
  return (dispatch) => {
    axios.get(`${AppConfig.FO_INITIAL_URL}/state/all`).then((res) => {
      dispatch({
        type: Types.FETCH_STATE_LIST,
        data: res.data
      });
    });
  };
};

export const createNewTenant = (data) => {
  return (dispatch) => {
    axios.post(`${AppConfig.FO_INITIAL_URL}/company-admin`, data).then((_) => dispatch({ type: Types.SEARCH_REFRESH }));
  };
};

export const updateTenantDetails = (data) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${AppConfig.FO_INITIAL_URL}/company-admin/update`, data, {validateStatus: () => true});
      if ((response.status != null && (response.status < 200 || response.status >= 300)) || response.data?.error) {
        throw new Error(response.data?.error || `Unable to update tenant (HTTP ${response.status}).`);
      }
      dispatch({
        type: UPDATE_COMPANY_FEATURES,
        payload: { ...data, ...(response.data && typeof response.data === 'object' ? response.data : {}) }
      });
      dispatch({ type: Types.SEARCH_REFRESH });
    } catch (err) {
      throw err;
    }
  };
};

export const changeTenantGoLiveStatus = (data) => {
  return (dispatch) => {
    axios
      .put(`${AppConfig.IAM_BACKEND_URL}/user/site-go-live/${data.code}`, { goLive: data.live })
      .then((_) => {
        trackClick(trackingTypes.TENANT, trackingActions.UPDATE, `${data.id}:${data.code}`, `live:${data.live}`);
        dispatch({ type: Types.SEARCH_REFRESH });
      });
  };
};

export const syncTenantGoLiveAndAiSummary = (data) => {
  return async (dispatch) => {
    await axios.put(`${AppConfig.IAM_BACKEND_URL}/user/site-go-live/${data.code}`, { goLive: data.live });

    if (data.live && data.aiSummaryEnabled !== true) {
      await axios.put(`${AppConfig.FO_INITIAL_URL}/company-admin/ai-summary/${data.id}/true`);
    }

    dispatch({ type: Types.SEARCH_REFRESH });
  };
};

export const activateCompany = (id) => {
  return (dispatch) => axios.put(`${AppConfig.FO_INITIAL_URL}/company-admin/activate/${id}`).then((_) => dispatch({ type: Types.SEARCH_REFRESH }));
};

export const deactivateCompany = (id) => {
  return (dispatch) => axios.put(`${AppConfig.FO_INITIAL_URL}/company-admin/deactivate/${id}`).then((_) => dispatch({ type: Types.SEARCH_REFRESH }));
};

export const deactivateTenant = ({ id, code, live, aiSummaryEnabled }) => {
  return async (dispatch) => {
    await axios.put(`${AppConfig.FO_INITIAL_URL}/company-admin/deactivate/${id}`);

    if (live) {
      await axios.put(`${AppConfig.IAM_BACKEND_URL}/user/site-go-live/${code}`, { goLive: false });
    }

    if (aiSummaryEnabled) {
      await axios.put(`${AppConfig.FO_INITIAL_URL}/company-admin/ai-summary/${id}/false`);
    }

    dispatch({ type: Types.SEARCH_REFRESH });
  };
};

export const toggleAiSummary = (id, enabled) => {
  return (dispatch) =>
    axios
      .put(`${AppConfig.FO_INITIAL_URL}/company-admin/ai-summary/${id}/${enabled}`)
      .then((response) => {
        dispatch({
          type: UPDATE_COMPANY_FEATURES,
          payload: { id, aiSummaryEnabled: enabled, ...(response.data && typeof response.data === 'object' ? response.data : {}) }
        });
        dispatch({ type: Types.SEARCH_REFRESH });
      });
};

export const toggleCampaignEnabled = (id, enabled) => {
  return (dispatch) =>
    axios
      .put(`${AppConfig.FO_INITIAL_URL}/company-admin/campaign-enabled/${id}/${enabled}`)
      .then((response) => {
        dispatch({
          type: UPDATE_COMPANY_FEATURES,
          payload: { id, campaignEnabled: enabled, ...(response.data && typeof response.data === 'object' ? response.data : {}) }
        });
        dispatch({ type: Types.SEARCH_REFRESH });
      });
};

export const updateTenantFiltersEnabled = (id, filtersEnabled) => {
  return (dispatch) => axios.put(`${AppConfig.FO_INITIAL_URL}/company-admin/filters/${id}`, { filtersEnabled }).then((response) => {
    dispatch({
      type: UPDATE_COMPANY_FEATURES,
      payload: { id, filtersEnabled, ...(response.data && typeof response.data === 'object' ? response.data : {}) }
    });
    dispatch({ type: Types.SEARCH_REFRESH });
  });
};
